import { BetTypeEnum } from '@/ui-components/components/BetLotto/BetLotto.types'
import { FunctionMenuEnum, TWO_NUMBER_LIST } from '../constants'
import { BetType } from '../types'

/**
 * Determines if a bet type should be rendered based on the current selection
 * Handles special cases for two-digit bets and ensures valid bet type combinations
 *
 * @param key - The bet type to check
 * @param selected - Array of currently selected bet types
 * @returns boolean - Whether the bet type should be rendered
 */
export const isAllowToRenderBetType = (key: BetType, selected: BetType[]) => {
  const isRenderSpecialTwoDigit =
    ((TWO_NUMBER_LIST.includes(key as (typeof TWO_NUMBER_LIST)[number]) &&
      selected?.includes(BetTypeEnum.TWO_TOP)) ||
      selected?.includes(BetTypeEnum.TWO_UNDER)) &&
    !selected.includes(BetTypeEnum.THREE_TOP) &&
    !selected.includes(BetTypeEnum.THREE_TOD) &&
    !selected.includes(FunctionMenuEnum.SWAP_THREE)

  const isNotTwoNumber = !TWO_NUMBER_LIST.includes(
    key as (typeof TWO_NUMBER_LIST)[number],
  )
  return isNotTwoNumber || isRenderSpecialTwoDigit
}
